<template>
  <div>

    <agile-table
      :data="addresses"
      :data-type="'addresses'"
      :table-meta="tableMeta"
      :filter-meta="filterMeta"
      :action-meta="actionMeta"
      :column-meta="columnMeta"
      @rowAction="rowAction"
      @fieldAction="fieldAction"
      @tableAction="tableAction" />

      <new-button @clicked="openAddressModal" />

    <slideout-panel />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import NewButton from '@/components/actions/CreateNewButton'
import AgileTable from '@/components/table/AgileTable'
import AddressModal from '@/components/modals/AddressModal'

export default {
  components: {
    NewButton,
    AgileTable
  },
  data () {
    return {
      debounceDelay: process.env.DEBOUNCE_DELAY,

      project: {},

      filterMeta: [],

      tableMeta: {
        headingIcon: 'fa-map-marked-alt',
        actions: [{
          label: 'Personer',
          action: 'goToContacts',
          iconClass: 'fal fa-user-alt'
        }]
      },

      columnMeta: {
        hasActions: true,
        items: [{
          fieldId: 'customerName',
          label: 'Kund'
        },
        {
          fieldId: 'name',
          label: 'Objekt'
        },
        {
          fieldId: 'addressType',
          label: 'Adresstyp'
        },
        {
          fieldId: 'address1',
          label: 'Adressrad 1'
        },
        {
          fieldId: 'address2',
          label: 'Adressrad 2'
        },
        {
          fieldId: 'postalCode',
          label: 'Postnummer'
        },
        {
          fieldId: 'city',
          label: 'Ort'
        }]
      },

      actionMeta: {
        type: 'buttons',
        items: [{
          label: 'Ändra',
          action: 'updateAddress',
          iconClass: 'fal fa-pen'
        }]
      }
    }
  },

  watch: {
    'addresses.filter': {
      handler () {
        this.$store.state.addresses.all.currentPage = 1
        this.getListData()
      },
      deep: true
    },
    '$route': 'routeUpdate'
  },

  computed: {
    ...mapState({
      addresses: state => state.addresses.all
    })
  },

  beforeMount () {
    this.routeUpdate()
  },

  methods: {
    ...mapActions('addresses', ['initialize', 'getListData', 'delete']),
    ...mapActions('projects', ['getById']),

    rowAction (action, address) {
      switch (action) {
        case 'updateAddress':
          this.openAddressModal(address.addressId)
          break
        case 'deleteAddress':
          this.deleteAddress(address)
          break
        default:
          this.$alert(action + ' is not defined!')
          break
      }
    },

    fieldAction (action, address) {
      switch (action) {
        default:
          this.$alert(action + ' is not defined!')
          break
      }
    },

    tableAction (action) {
      switch (action) {
        case 'goToContacts':
          if (this.$route.params.projectId) {
            this.$router.push({ name: 'Contacts_Persons_Project', params: { projectId: this.$route.params.projectId } })
          } else {
            this.$router.push({ name: 'Contacts_Persons' })
          }
          break
      }
    },

    openAddressModal (id) {
      if (this.project.customerId) {
        this.$panel(AddressModal, { id, customerId: this.project.customerId, displayCustomer: false })
      } else {
        // this.$store.dispatch('addresses/newAddressModal')
        this.$panel(AddressModal, { id })
      }
    },

    routeUpdate () {
      if (this.$route.params.projectId) {
        this.filterMeta = []
        this.addresses.defaultFilter.projectId = this.$route.params.projectId
        this.addresses.filter.projectId = this.$route.params.projectId
      } else {
        this.project = {}
        this.filterMeta = [{
          fieldId: 'customerName',
          type: 'string',
          label: 'Kund'
        },
        {
          fieldId: 'name',
          type: 'string',
          label: 'Objekt'
        },
        {
          fieldId: 'city',
          type: 'string',
          label: 'Stad'
        }]
      }

      if (this.$route.params.projectId) {
        this.getById(this.$route.params.projectId).then(project => {
          this.project = project
        })
      }
    },

    deleteAddress (address) {
      this.$confirm('Radera adressen', 'Är du säker på att du vill radera adressen ' + address.name + '?').then((result) => {
        if (result.value) {
          this.delete(address.addressId)
          this.addresses.currentPage = 1
          this.getListData()
        }
      })
    }
  },

  created () {
    this.initialize()

    if (this.$store.state.auth.user.role === 'SuperAdmin' || this.$store.state.auth.user.role === 'Developer') {
      this.actionMeta.items.push({
        label: 'Radera',
        action: 'deleteAddress',
        iconClass: 'fal fa-trash'
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/pages/Admin/Contacts/AddressesPage.vue